import React from 'react';
import { Button } from 'primereact/button';
import { Content, Parallax } from '../../App';
import Footer from '../../components/Footer';
import MenuSection from './components/new/MenuSection';
import DeliverySection from './components/new/DeliverySection';
import QuantitySection from './components/new/QuantitySection';
import DateSection from './components/new/DateSection';
import styled from 'styled-components';

export const FormulaComparator = styled.div<{ items: number }>`
  display: grid;
  grid-gap: 8px;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));

  &.p-invalid {
    border: 1px solid var(--invalid);
  }
`;

export const FormulaGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 0.75rem;
`;

export const Questions = styled.div`
  padding: 32px;
  background-color: var(--green-40);
  text-align: center;

  @media only screen and (min-width: 600px) {
    padding: 8px 32px;
  }

  h3,
  p {
    margin: 0;
  }
`;

const signupUrl = 'https://www.mijnboer.be/groentegeweld/inschrijven/pakketten';

const featureCardClassName = [
  'surface-card',
  'border-1',
  'border-200',
  'border-round-2xl',
  'shadow-2',
  'overflow-hidden',
].join(' ');

const sectionCardClassName = [
  'surface-card',
  'border-1',
  'border-200',
  'border-round-2xl',
  'shadow-1',
  'p-3',
  'md:p-5',
].join(' ');

const formulaCardStyle = {
  background: 'linear-gradient(135deg, rgba(116, 143, 86, 0.08) 0%, rgba(238, 122, 49, 0.06) 100%)',
};

const formulaSizesHeaderClassName =
  'grid text-xs font-bold text-gray-500 uppercase border-bottom-1 border-200 pb-2 mb-1';

const formulaSizeRowClassName =
  'grid align-items-center py-2 border-bottom-1 border-100';

type FormulaSize = {
  name: string;
  price: number;
  total: number;
  code: string;
};

type Formula = {
  title: string;
  packages: string;
  rhythm: string;
  subtitle?: string;
  note?: string;
  sizes: FormulaSize[];
};

const formulas: Formula[] = [
  {
    title: 'Flex 40',
    packages: '40 pakketten',
    rhythm: 'Wekelijks',
    subtitle: 'februari - maart tweewekelijks',
    note: 'januari: geen pakketten',
    sizes: [
      // {
      //   name: 'Mini',
      //   price: 11.38,
      //   total: 455,
      //   code: 'groentegeweld|pakketten-2023-flex-40-mini',
      // },
      {
        name: 'Klein',
        price: 18.87,
        total: 755,
        code: 'pakketten-2023-flex-40-medium',
      },
      {
        name: 'Groot',
        price: 27.5,
        total: 1090,
        code: 'pakketten-2023-flex-40-large',
      },
    ],
  },
  {
    title: 'Flex 30',
    packages: '30 pakketten',
    rhythm: 'Wekelijks',
    subtitle: 'februari - maart tweewekelijks',
    note: 'januari: geen pakketten',
    sizes: [
      // {
      //   name: 'Mini',
      //   price: 11.83,
      //   total: 355,
      //   code: 'groentegeweld|pakketten-2023-flex-30-mini',
      // },
      {
        name: 'Klein',
        price: 20,
        total: 600,
        code: 'pakketten-2023-flex-30-medium',
      },
      {
        name: 'Groot',
        price: 28.67,
        total: 860,
        code: 'pakketten-2023-flex-30-large',
      },
    ],
  },
  {
    title: 'Flex 15',
    packages: '15 pakketten',
    rhythm: 'Tweewekelijks',
    subtitle: 'Heel het jaar',
    note: 'januari: geen pakketten',
    sizes: [
      // {
      //   name: 'Mini',
      //   price: 12.67,
      //   total: 190,
      //   code: 'groentegeweld|pakketten-2023-flex-15-mini',
      // },
      {
        name: 'Klein',
        price: 20.67,
        total: 310,
        code: 'pakketten-2023-flex-15-medium',
      },
      {
        name: 'Groot',
        price: 29.33,
        total: 440,
        code: 'pakketten-2023-flex-15-large',
      },
    ],
  },
  {
    title: 'Proef 8',
    packages: '8 pakketten',
    rhythm: 'Proefperiode',
    sizes: [
      // {
      //   name: 'Mini',
      //   price: 12,
      //   total: 95,
      //   code: 'groentegeweld|pakketten-2023-flex-trial-mini',
      // },
      {
        name: 'Klein',
        price: 20,
        total: 160,
        code: 'pakketten-2023-flex-trial-medium',
      },
      {
        name: 'Groot',
        price: 28.5,
        total: 230,
        code: 'pakketten-2023-flex-trial-large',
      },
    ],
  },
];

const formatPrice = (price: number) => {
  const [whole, decimals] = price.toFixed(2).split('.');
  return {whole, decimals};
};

const getSignupUrl = (code: string) =>
  `https://www.mijnboer.be/groentegeweld/inschrijven/pakketten?code=${code}`;

const BasketsPageNew = () => {
  return (
    <div>
      <section className="relative overflow-hidden">
        <Parallax img={'IMG_7906.jpg'} height={'70vh'} />
        <div className="absolute top-0 left-0 right-0 bottom-0 flex align-items-center">
          <div
            className="w-full"
            style={{
              background:
                'linear-gradient(90deg, rgba(0,0,0,0.76) 0%, rgba(0,0,0,0.42) 58%, rgba(0,0,0,0.12) 100%)',
            }}
          >
            <Content>
              <div className="py-6 md:py-8 text-white" style={{ maxWidth: '780px' }}>
                <div
                  className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-4"
                  style={{ background: 'rgba(255,255,255,0.20)', backdropFilter: 'blur(8px)' }}
                >
                  <i className="pi pi-shopping-bag" />
                  <span className="font-medium">Flexibele pakketten • lokaal • seizoensvers</span>
                </div>

                <h1 className="m-0 mb-3 text-4xl md:text-6xl line-height-1 font-bold">
                  Groentepakketten
                </h1>

                <p className="text-lg md:text-2xl line-height-3 mb-4" style={{ maxWidth: '700px' }}>
                  Wekelijks of tweewekelijks kraakverse groenten van ons veld. Jij kiest de formule, wij zorgen voor
                  smaak, variatie en korte keten.
                </p>

                <div className="flex flex-wrap gap-3 mb-4">
                  <span className="px-3 py-2 border-round-3xl font-medium" style={{ background: 'rgba(255,255,255,0.22)' }}>
                    Flexibel kiezen
                  </span>
                  <span className="px-3 py-2 border-round-3xl font-medium" style={{ background: 'rgba(255,255,255,0.22)' }}>
                    Afhalen in de buurt
                  </span>
                  <span className="px-3 py-2 border-round-3xl font-medium" style={{ background: 'rgba(255,255,255,0.22)' }}>
                    Recht van het veld
                  </span>
                </div>

                <Button
                  label={'Schrijf mij in voor een flex-pakket'}
                  icon={'pi pi-arrow-right'}
                  iconPos={'right'}
                  className={'color-white bg-orange p-button-lg'}
                  onClick={() => window.open(signupUrl, '_blank')}
                />
              </div>
            </Content>
          </div>
        </div>
      </section>

      <Content>
        <div className="py-5 md:py-6">
          <div className="mb-4 flex flex-column align-items-center text-center">
            <div
              className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-3"
              style={{ background: 'var(--green-20)' }}
            >
              <i className="pi pi-list" />
              <span className="font-medium">Hoe werkt het?</span>
            </div>

            <h2 className="mt-0 mb-2 text-3xl md:text-4xl">
              Een pakket dat past bij jouw ritme
            </h2>

            <p className="m-0 text-lg line-height-3" style={{ maxWidth: '760px' }}>
              Kies je pakketgrootte, bepaal hoe vaak je groenten wil ontvangen en haal ze op aan een afhaalpunt dat voor
              jou handig is.
            </p>
          </div>

          <div className="grid">
            <div className="col-12 md:col-4">
              <div className={sectionCardClassName + ' h-full'}>
                <i className="pi pi-shopping-bag text-3xl color-orange" />
                <h3 className="mb-2 text-2xl">Wat zit erin?</h3>
                <p className="line-height-3 mb-0">
                  Een gevarieerd pakket met seizoensgroenten, afgestemd op wat het veld op dat moment het mooist geeft.
                </p>
              </div>
            </div>

            <div className="col-12 md:col-4">
              <div className={sectionCardClassName + ' h-full'}>
                <i className="pi pi-calendar text-3xl color-orange" />
                <h3 className="mb-2 text-2xl">Wanneer?</h3>
                <p className="line-height-3 mb-0">
                  Kies voor een wekelijks, tweewekelijks of proefpakket. Zo past het pakket bij jouw gezin en keuken.
                </p>
              </div>
            </div>

            <div className="col-12 md:col-4">
              <div className={sectionCardClassName + ' h-full'}>
                <i className="pi pi-map-marker text-3xl color-orange" />
                <h3 className="mb-2 text-2xl">Waar afhalen?</h3>
                <p className="line-height-3 mb-0">
                  Je haalt je pakket op bij éen van onze afhaalpunten. Korter, lokaler en praktischer.
                </p>
              </div>
            </div>
          </div>
        </div>
      </Content>

        <div className="py-4 md:py-6">
          <div className={sectionCardClassName}>
            <MenuSection />
          </div>
        </div>

        <div className="py-4 md:py-6">
          <div className={sectionCardClassName}>
            <QuantitySection />
          </div>
        </div>

        <div className="py-4 md:py-6">
          <div className={sectionCardClassName}>
            <DateSection />
          </div>
        </div>

      <section className="my-4 md:my-6">
        <Parallax img={'zonnebloem.jpg'} height={'220px'} />
      </section>

      <Content>
        <div className="py-4 md:py-6">
          <div className="mb-4 flex flex-column align-items-center text-center">
            <div
              className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-3"
              style={{ background: 'var(--orange-20)' }}
            >
              <i className="pi pi-euro" />
              <span className="font-medium">Formules en prijzen</span>
            </div>

            <h2 className="mt-0 mb-2 text-3xl md:text-4xl">
              Kies jouw flex-pakket
            </h2>

            <p className="m-0 text-lg line-height-3" style={{ maxWidth: '760px' }}>
              Elk pakket heeft drie groottes. De prijs per pakket is een gemiddelde, want de inhoud volgt het seizoen.
            </p>
          </div>

          <FormulaGrid>
            {formulas.map(formula => (
              <div
                key={formula.title}
                className={featureCardClassName + ' h-full flex flex-column gap-2'}
                style={formulaCardStyle}
              >
                <div className="flex-grow-1 p-3 border-bottom-1 border-200">
                  <div className="flex justify-content-between align-items-start gap-3">
                    <div>
                      <h3 className="m-0 mb-1 text-xl line-height-1 font-bold color-green">
                        {formula.title}
                      </h3>
                      <div className="text-sm text-gray-600 white-space-nowrap">
                        {formula.packages}
                      </div>
                    </div>

                    <div className="text-right">
                      <div className="font-bold color-orange">
                        {formula.rhythm}
                      </div>
                      {formula.subtitle && (
                        <div className="text-xs color-green">
                          {formula.subtitle}
                        </div>
                      )}
                    </div>
                  </div>

                  {formula.note && (
                    <div className="mt-2 text-xs text-gray-500 font-italic">
                      {formula.note}
                    </div>
                  )}
                </div>

                <div className="p-3">
                  <div className={formulaSizesHeaderClassName}>
                    <div className="col-3">Maat</div>
                    <div className="col-4 text-right">Pakket</div>
                    <div className="col-5 text-right">Totaal</div>
                  </div>

                  {formula.sizes.map(size => {
                    const priceFormatted = formatPrice(size.price);
                    const totalFormatted = formatPrice(size.total);
                    return (
                      <div className={formulaSizeRowClassName} key={size.name}>
                        <div className="col-3 font-bold color-green">
                          {size.name}
                        </div>
                        <div className="col-4 text-right text-lg font-bold color-orange">
                          € {priceFormatted.whole}<span style={{fontSize: '0.7em'}}>,{priceFormatted.decimals}</span>
                        </div>
                        <div className="col-5 text-right text-sm text-gray-600">
                          € {totalFormatted.whole}<span style={{fontSize: '0.7em'}}>,{totalFormatted.decimals}</span>
                        </div>
                      </div>
                    );
                  })}

                  <div className="mt-3 flex justify-content-end">
                    <Button
                      label={'Kies formule'}
                      icon={'pi pi-arrow-right'}
                      iconPos={'right'}
                      className={'p-button-outlined p-button-orange p-button-sm'}
                      onClick={() => window.open(getSignupUrl(formula.sizes[1]?.code || formula.sizes[0].code), '_blank')}
                    />
                  </div>
                </div>
              </div>
            ))}
          </FormulaGrid>

          <p className="font-italic text-sm mt-3">
            * Niet elk pakket zal even groot zijn, de prijs is dan ook een gemiddelde.
          </p>
        </div>
      </Content>

        <div className="py-4 md:py-6">
          <div className={sectionCardClassName}>
            <DeliverySection />
          </div>
        </div>

      <Content>
        <div className="py-4 md:py-6">
          <div className="grid align-items-center">
            <div className="col-12 lg:col-5">
              <div className={featureCardClassName}>
                <img
                  alt={'Basisproducten zoals aardappelen en uien'}
                  src={'potato-onion.png'}
                  className="block w-full"
                  style={{ minHeight: '280px', objectFit: 'contain', mixBlendMode: 'multiply' }}
                />
              </div>
            </div>

            <div className="col-12 lg:col-7">
              <div
                className={sectionCardClassName}
                style={{
                  background:
                    'linear-gradient(135deg, rgba(116, 143, 86, 0.10) 0%, rgba(238, 122, 49, 0.08) 100%)',
                }}
              >
                <div
                  className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-4"
                  style={{ background: 'var(--orange-20)' }}
                >
                  <i className="pi pi-plus-circle" />
                  <span className="font-medium">En er is meer...</span>
                </div>

                <h2 className="mt-0 mb-3 text-3xl md:text-4xl">
                  Ook basisproducten voor thuis
                </h2>

                <p className="text-lg line-height-3 mb-0">
                  Basisproducten zoals <strong>eieren, aardappelen of uien</strong> kan je ook bij ons bestellen.
                  We produceren ze meestal niet op eigen veld, maar laten dit over aan bevriende bioboeren uit de buurt.
                  Zo maak je opnieuw voor heel wat producten de keten korter en heb je ze steeds in huis.
                </p>
              </div>
            </div>
          </div>
        </div>
      </Content>

      <Content>
        <div className="py-4 md:py-6">
          <div
            className="border-round-2xl shadow-2 p-4 md:p-6 text-center"
            style={{
              background:
                'linear-gradient(135deg, rgba(116, 143, 86, 0.18) 0%, rgba(238, 122, 49, 0.14) 100%)',
            }}
          >
            <div
              className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-4"
              style={{ background: 'rgba(255,255,255,0.65)' }}
            >
              <i className="pi pi-check-circle" />
              <span className="font-medium">Klaar om mee te doen?</span>
            </div>

            <h2 className="mt-0 mb-3 text-3xl md:text-4xl">
              Ja, ik wil een flex-pakket!
            </h2>

            <p className="text-lg line-height-3 mx-auto mb-4" style={{ maxWidth: '720px' }}>
              Schrijf je in via MijnBoer. Kies je formule, pakketgrootte en afhaalpunt.
            </p>

            <Button
              label={'Naar het inschrijvingsformulier'}
              icon={'pi pi-external-link'}
              iconPos={'right'}
              className={'color-white bg-orange p-button-lg'}
              onClick={() => window.open(signupUrl, '_blank')}
            />
          </div>
        </div>
      </Content>

      <Content>
        <div>
          <Questions
            className="border-round-2xl shadow-2 p-4 md:p-5"
            style={{
              background:
                'linear-gradient(135deg, rgba(116, 143, 86, 0.18) 0%, rgba(238, 122, 49, 0.14) 100%)',
            }}
          >
            <div
              className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-3"
              style={{ background: 'rgba(255,255,255,0.65)' }}
            >
              <i className="pi pi-question-circle" />
              <span className="font-medium">Nog vragen?</span>
            </div>

            <h3 className="mt-0 mb-2 text-2xl md:text-3xl">
              Zit je nog met vragen?
            </h3>

            <p className="m-0 text-lg line-height-3">
              Aarzel niet om ons te{' '}
              <a className="color-orange font-bold" href={'mailto:info@groentegeweld.be'}>
                contacteren
              </a>
              .
            </p>
          </Questions>
        </div>
      </Content>

      <Footer />
    </div>
  );
};

export default BasketsPageNew;
